jQuery(document).ready(function($) {

    // --- Desktop Dropdown Transformation (Runs only ONCE on first hover) ---
    var desktopMenuItem = $('.desktop-navigation li.js-has-dropdown');

    // Use .one() to ensure this transformation only ever happens a single time.
    // This is the definitive fix for the duplication issue.
    desktopMenuItem.one('mouseenter', function() {

        var subMenu = $(this).find('.sub-menu');

        if (subMenu.length > 0) {
            var title = $(this).children('a').text().trim() + '...';
            var headerHtml = '<div class="sub-menu__header">' +
                '<h3 class="dropdown-title">' + title + '</h3>' +
                '<p class="dropdown-subtitle">Shop by category</p>' +
                '</div>';
            var imageHtml = '<div class="sub-menu__image">' +
                '<img src="/wp-content/themes/ultimate-collars/assets/images/UC_DropDown.png" alt="' + title + '">' +
                '</div>';

            var listItems = subMenu.children('li');
            var linksContainer = $('<div class="sub-menu__links"></div>').append(listItems);
            linksContainer.prepend(headerHtml);
            subMenu.empty().append(linksContainer).append(imageHtml);
        }
    });


    // --- Mobile Menu Toggle & Accordion Logic (No changes here, it's correct) ---
    var mobileToggle = $('.mobile-nav-toggle');

    mobileToggle.on('click', function() {
        $(this).toggleClass('is-open');
        $('body').toggleClass('mobile-menu-is-open');
    });

    var mobileMenu = $('.mobile-menu');

    mobileMenu.find('.menu-item-has-children').each(function() {
        if ($(this).find('.sub-menu-toggle').length === 0) {
            $(this).append('<button class="sub-menu-toggle" aria-label="Toggle sub-menu"></button>');
        }
    });

    mobileMenu.find('.sub-menu-toggle').on('click', function(e) {
        e.preventDefault();
        var parentItem = $(this).parent('li');
        $(this).toggleClass('is-active');
        parentItem.children('.sub-menu').slideToggle(300);
    });

});